export interface EstimateCostOfWork {
  NewBuildingCost: number | null;
  RehabilitationCost: number | null;
  NewVolume: number | null;
  NewArea: number | null;
}

export interface WorkItem {
  Item: string;
  check: boolean;
  Cost: number;
  FenceHeight?: number | null;
  WallArea?: number | null;
  SignType?: string | null;
  SignArea?: number | null;
  PoolItem?: string | null;
  PoolArea?: number | null;
  name?: string;
}

export interface GetAllFee {
  'Building Size': number;
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface BuildingData {
  EstimateCostOfWork: EstimateCostOfWork;
  WorkItems: WorkItem[];
  getAllFee: GetAllFee;
}

export const buildingData: BuildingData = {
  EstimateCostOfWork: {
    NewBuildingCost: null,
    RehabilitationCost: null,
    NewVolume: null,
    NewArea: null,
  },
  WorkItems: [
    { Item: 'New Building', check: false, Cost: 0 },
    { Item: 'Renovation', check: false, Cost: 0 },
    { Item: 'Demolition', check: false, Cost: 0 },
    { Item: 'Addition', check: false, Cost: 0 },
    { Item: 'Roofing', check: false, Cost: 0 },
    { Item: 'Fence', check: false, Cost: 0, FenceHeight: null },
    { Item: 'Retaining Wall', check: false, Cost: 0, WallArea: null },
    { Item: 'Sign', check: false, Cost: 0, SignType: null, SignArea: null },
    {Item: 'Pool', check: false, Cost: 0,PoolItem: null,PoolArea: null,name: '',},
    { Item: 'Radon Remediation', check: false, Cost: 0 },
    { Item: 'Siding', check: false, Cost: 0 },
    { Item: 'Asbestos Abatement Subchapter 8', check: false, Cost: 0 },
  ],
  getAllFee: {
    'Building Size': 0,
    'Certification Cost': 0,
    totalFee: 0,
    summary: [],
  },
};
